import { IonIcon } from '@ionic/react'
import {
  calendarOutline,
  cardOutline,
  megaphoneOutline,
  notificationsOutline,
  pricetagOutline,
} from 'ionicons/icons';

interface NotificationData {
  id: string;
  type: string;
  content: string;
  timestamp: string;
  isNew: boolean;
  subject?: string;
  link?: string;
}

interface NotificationItemProps {
  notification: NotificationData;
  onClick?: () => void;
}

const NotificationItem: React.FC<NotificationItemProps> = ({ notification, onClick }) => {
  console.log('ss', notification);
  const getIcon = (type: string): string => {
    switch (type) {
      case 'reminder':
      case 'appointment':
        return calendarOutline;
      case 'payment':
        return cardOutline;
      case 'offer':
        return pricetagOutline;
      case 'system':
        return megaphoneOutline;
      default:
        return notificationsOutline;
    }
  };

  return (
    <div className={`notification-item ${notification.isNew ? 'new' : ''}`} onClick={onClick}>
      <div className={`icon-wrapper ${notification.type}`}>
        <IonIcon icon={getIcon(notification.type)} />
      </div>
      <div className='notification-content'>
        <p className='message'>{notification.content}</p>
        <span className='timestamp'>{notification.timestamp}</span>
      </div>
      {notification.isNew && <div className='new-indicator' />}
    </div>
  );
};

export default NotificationItem;